export const agenticService = '/agentous-agentic-service';
export const agenticUserService = '/agentous-user-service';
export const integrationService = '/agentous-integration-service';
